<template>
  <div class="condition-panel">
    <template v-if="appId">
      <form-item label="指标">
        <c-selector
          :store="targetList"
          @change="onChangeTarget"
          v-model="target"
          labelField="name"
          keyField="value"
        ></c-selector>
        <c-tooltip class="tip" v-if="target.value === 'pv'" content="用户的一次打开和启动产品，会被认为是一次访问；即一个会话为一次访问">
          <i class="cicon-help"></i>
        </c-tooltip>
      </form-item>
      <form-item
        label="按属性细分"
        style="margin-left: 20px"
        v-if="['duration_avg', 'duration'].indexOf(target.value) === -1"
      >
        <biz-dimension-selector
          :appId="appId"
          :platform="platform"
          v-model="dimension"
          keyField="dimensionId"
          haveUserProp
          :realTimeAble="!isSaaS"
        ></biz-dimension-selector>
        <i
          class="cicon-remove btn-del"
          v-if="dimension"
          @click="dimension = null"
        ></i>
      </form-item>
      <i
        class="warning-btn icon-alert"
        v-if="isSaaS && ['add', 'active'].indexOf(target.value) > -1"
        @click="$emit('biz-create-warning')"
      ></i>
      <div
        class="filter-group"
        v-if="['duration_avg', 'duration'].indexOf(target.value) === -1"
      >
        <form-item label="筛选" :style="{marginLeft: target.value === 'pv' ? '19px' : '0'}">
          <div
            class="condition-item_"
            v-for="item in conditions"
            :key="item.id"
          >
            <biz-condition-item
              v-model="item.value"
              :appId="appId"
              :platform="platform"
              keyField="dimensionId"
              haveUserProp
              :realTimeAble="!isSaaS"
              isOld
            ></biz-condition-item>
            <i
              class="cicon-remove btn-del"
              v-if="conditions.length > 1"
              :key="item.id + '_btn-del'"
              @click="onDelCondition(item)"
            ></i>
          </div>
        </form-item>
      </div>
      <div
        class="condition-foot"
        v-if="['duration_avg', 'duration'].indexOf(target.value) === -1"
      >
        <c-button
          type="primary"
          size="normal"
          @click="onClickSearch"
          :disable="!queryAble"
        >
          查询
        </c-button>
      </div>
    </template>
  </div>
</template>

<script>
import FormItem from '../../components/formItem'
import { mapState } from 'vuex'
export default {
  name: 'wholeCondition',
  components: { FormItem },
  props: {
    value: null,
    maxCount: {
      type: Number,
      default: 5
    }
  },
  data () {
    let data = {
      targetList: [
        { name: '新增用户', value: 'add' },
        { name: '活跃用户', value: 'active' },
        { name: '访问次数', value: 'pv' },
        { name: '平均使用时长', value: 'duration_avg' },
        { name: '使用时长分布', value: 'duration' }
      ],
      target: { value: 'add' },
      dimension: null,
      conditions: [
        {
          id: this.$util.guid(),
          value: null
        }
      ],
      preOutput: null
    }
    if (this.value) {
      if (this.value.target) {
        data.target = this.value.target
      }
      if (this.value.dimensionSub) {
        data.dimension = this.value.dimensionSub
      }
      if (this.value.conditions) {
        data.conditions = []
        let eventConditions = this.value.conditions.eventCondition
          .eventSingleConditions
        eventConditions.forEach(item => {
          item.attrConditions.forEach(condition => {
            data.conditions.push({
              id: this.$util.guid(),
              value: {
                isEventProp: true,
                condition
              }
            })
          })
          item.environmentConditions.forEach(condition => {
            data.conditions.push({
              id: this.$util.guid(),
              value: {
                isEventEnv: true,
                condition
              }
            })
          })
        })
        this.value.conditions.userCondition.userSingleConditions.forEach(
          condition => {
            data.conditions.push({
              id: this.$util.guid(),
              value: {
                isUserProp: true,
                condition
              }
            })
          }
        )
      }
    }
    return data
  },
  computed: {
    ...mapState({
      ready (state) {
        return state.bizSys.ready.userProps && state.bizSys.ready.eventEnvs
      }
    }),
    queryAble () {
      let pre = this.preOutput // this.$util.clone(this.preOutput)
      let now = this.output // this.$util.clone(this.output)
      // 因为条件里面的happenTime是后续补充上去的，所以
      return !this.$util.equal(pre, now)
    },
    output () {
      let res = {
        target: this.target,
        dimensionSub: this.dimension,
        conditions: {
          eventCondition: {
            eventSingleConditions: [
              {
                attrConditions: [],
                environmentConditions: [],
                eventId: 0,
                happenTime: {
                  name: 'happenTime',
                  operator: 'between',
                  params: ['relative', 30, 1, 'day'],
                  type: 3
                } // 需要外面补时间
              }
            ],
            operator: 'and',
            isNew: true
          },
          userCondition: {
            operator: 'and',
            userSingleConditions: []
          }
        },
        exist: false
      }
      if (['duration_avg', 'duration'].indexOf(this.target.value) > -1) {
        res.conditions = undefined
        res.dimensionSub = null
      }
      this.conditions.forEach(item => {
        if (item.value && item.value.condition) {
          res.exist = true
          let condition = item.value.condition
          if (item.value.isEventEnv) {
            // 触发环境
            res.conditions.eventCondition.eventSingleConditions[0].environmentConditions.push(
              condition
            )
          } else {
            res.conditions.userCondition.userSingleConditions.push(condition)
          }
        }
      })
      if (!res.exist) delete res.conditions
      return res
    },
    eventId () {
      return this.target.value === 'add' ? -3 : -4
    }
  },
  watch: {
    appId () {
      this.reset()
    },
    platform () {
      this.reset()
    },
    conditions: {
      handler: function (conditions) {
        let condition = conditions[conditions.length - 1]
        if (condition.value && this.conditions.length < this.maxCount) {
          // 如果当前筛选条件插入了值，并且还是最后一个筛选条件，并且筛选条件个数没超限，则增加一个筛选条件
          this.addCondition()
        }
        this.$emit('input', this.$util.clone(this.output))
      },
      deep: true
    },
    ready (ready) {
      if (ready) {
        this.onQuery()
      }
    }
  },
  mounted () {
    if (this.ready) this.onQuery()
  },
  methods: {
    // 把所有条件全部重置
    reset () {
      this.dimension = null
      this.conditions = [
        {
          id: this.$util.guid(),
          value: null
        }
      ]
    },
    onChangeTarget () {
      this.dimension = null
      this.conditions = [
        {
          id: this.$util.guid(),
          value: null
        }
      ]
      this.onQuery()
      this.$emit('changeTarget')
    },
    onAddWarning () {
      this.$emit('bizCreateWarning')
    },
    addCondition () {
      this.conditions.push({
        id: this.$util.guid(),
        value: null
      })
    },
    onDelCondition (condition) {
      this.conditions.forEach((item, i) => {
        if (item.id === condition.id) {
          this.conditions.splice(i, 1)
        }
      })
      if (!this.conditions.length) {
        this.addCondition()
      }
    },
    onClickSearch () {
      this.onQuery()
      this.$emit('onClickSearch')
    },
    setPreOutput () {
      this.preOutput = this.$util.clone(this.output)
    },
    onQuery () {
      if (!this.queryAble) return
      this.preOutput = this.$util.clone(this.output)
      this.$emit('input', this.$util.clone(this.output))
      this.$emit('change')
    }
  }
}
</script>

<style lang="sass">
@import "styles/condition"
</style>
